import { createRouter, createWebHistory } from 'vue-router';
import modules from '@/router/routes-registration';
import { APPLICATIONS } from '@/services/consts/application';
import * as middlewares from '@/router/middlewares';

import HelpPage from '@/components/help-online/HelpOnline.vue'; // Assuming this is your Help Page component

// Original route definitions
const rawRoutes = [
  {
    path: '/',
    name: 'r_home',
    meta: {
      middlewares: {
        auth: null,
        document: { applicationId: APPLICATIONS.APP_CLEBEX_HUB.id },
      },
    },
    component: () => import('../views/Welcome.vue'),
    children: [
      {
        path: 'home',
        name: 'r_home-alt',
        meta: {
          middlewares: {
            auth: null,
            document: { applicationId: APPLICATIONS.APP_CLEBEX_HUB.id },
          },
        },
        component: () => import('../views/Welcome.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'r_login',
    meta: { middlewares: {} },
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/tmp-code',
    name: 'r_tmp-code',
    meta: { middlewares: {} },
    component: () => import('../views/TmpCodeLogin.vue'),
  },
  {
    path: '/forgot-password',
    name: 'r_forgot-password',
    meta: {},
    component: () => import('../views/ForgotPassword.vue'),
  },
  {
    path: '/reset-password',
    name: 'r_reset-password',
    meta: {},
    component: () => import('../views/ResetPassword'),
  },
  {
    path: '/permissions',
    name: 'r_permissions',
    meta: {
      middlewares: { auth: null },
    },
    component: () => import('../views/Permissions.vue'),
  },
  {
    path: '/404',
    name: 'r_error',
    meta: {
      middlewares: { auth: null },
    },
    component: () => import('../views/ErrorPage'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'r_not-found',
    meta: { middlewares: {} },
    redirect: { name: 'r_error' },
  },
  ...modules,
];

// Recursive helper to append help routes
function appendHelpRoutes(routes) {
  return routes.map((route) => {
    const hasChildren = Array.isArray(route.children) && route.children.length > 0;

    const newChildren = hasChildren ? appendHelpRoutes(route.children) : [];

    // Only append help if route has a name and a component (i.e., is navigable)
    const helpRoute =
      route.name && route.component
        ? [
            {
              path: 'help',
              name: `${route.name}-help`,
              component: HelpPage,
              meta: { hidden: true },
              props: { backLinkName: route.name },
            },
          ]
        : [];

    return {
      ...route,
      children: [...newChildren, ...helpRoute],
    };
  });
}

const routes = appendHelpRoutes(rawRoutes);

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  let result = Promise.resolve(middlewares.main({ to }));
  Object.keys(to.meta.middlewares || {}).forEach((current) => {
    result = result.then((res) => {
      if (typeof res === 'object') {
        return res;
      }
      let data = {};
      if (typeof to.meta.middlewares[current] !== 'undefined') {
        data = to.meta.middlewares[current];
      }
      return middlewares[current]({ to, from, next, data });
    });
  });
  return result.then((res) => next(res));
});

export default router;
